import { Alert, Platform } from 'react-native';
import swal from 'sweetalert2';

export const Confirm = async (title, description, cancelText, okText) => {
  return new Promise(async (resolve, reject) => {
    if (Platform.OS === 'web') {
      const { value } = await swal.fire({
        title,
        text: description,
        showCancelButton: true,
        reverseButtons: true,
        icon: 'question',
        cancelText,
        confirmButtonText: okText
      });
      if (value) resolve();
      else reject();
    } else {
      Alert.alert(
        title,
        description,
        [
          {
            text: cancelText,
            onPress: () => reject(),
            style: 'cancel'
          },
          { text: okText, onPress: () => resolve() }
        ],
        { cancelable: false }
      );
    }
  });
};

export const Info = (title, description) => {
  if (Platform.OS === 'web') {
    swal.fire({
      title,
      text: description,
      icon: 'info'
    });
  } else {
    Alert.alert(title, description, [{ text: 'Ok', onPress: () => {} }]);
  }
};
